<template>
  <template v-if="isCollapsible">
    <div v-if="!model.hidden && description" class="xl:max-w-[50%]">
      <VcCollapsibleContent max-height="18.75rem" class="text-base text-neutral-600">
        <VcTypography tag="h2" variant="h3" class="mb-4">
          {{ model.title || $t("shared.catalog.product_details.description_block_title") }}
        </VcTypography>
        <VcMarkdownRender :src="description" />
      </VcCollapsibleContent>
    </div>
  </template>

  <template v-else>
    <div v-if="!model.hidden && description" class="xl:max-w-[50%]">
      <VcTypography tag="h2" variant="h3" class="mb-4 text-[--color-body-text]">
        {{ model.title || $t("shared.catalog.product_details.description_block_title") }}
      </VcTypography>
      <div class="text-base"><VcMarkdownRender :src="description" /></div>
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { Product } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
  isCollapsible?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isCollapsible: true,
});

const description = computed<string | undefined>(() => props.product.description?.content);
</script>
